var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "table-row-actions d-flex align-center justify-content-center"
    },
    [
      _vm.isInlineMode
        ? _vm._l(_vm.visibleActions, function(action, index) {
            return _c(
              "v-tooltip",
              {
                key: _vm.getActionKey(action, index),
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "span",
                            _vm._g(
                              _vm._b(
                                { class: _vm.actionWrapperClass(action) },
                                "span",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    disabled: !!action.disabled,
                                    loading: !!action.loading
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.onClick(action)
                                    }
                                  }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: action.icon,
                                      color: _vm.getActionColor(action),
                                      size: _vm.iconSize
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              },
              [_c("span", [_vm._v(_vm._s(action.tooltip))])]
            )
          })
        : [
            _c(
              "v-menu",
              {
                attrs: { "offset-y": "", left: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              { attrs: { icon: "", small: "" } },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: _vm.menuIcon,
                                color: _vm.menuColor,
                                size: _vm.iconSize
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              },
              [
                _c(
                  "v-list",
                  { attrs: { dense: "" } },
                  [
                    _vm._l(_vm.menuNormalActions, function(action, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: "normal-" + _vm.getActionKey(action, index),
                          attrs: { disabled: !!action.disabled },
                          on: {
                            click: function($event) {
                              return _vm.onClick(action)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: action.icon,
                                  color: _vm.getActionColor(action),
                                  size: _vm.iconSize
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-list-item-title", [
                            _vm._v(" " + _vm._s(action.tooltip) + " ")
                          ])
                        ],
                        1
                      )
                    }),
                    _vm.hasMenuDivider
                      ? _c("v-divider", {
                          staticClass: "table-row-actions__divider"
                        })
                      : _vm._e(),
                    _vm._l(_vm.menuDangerActions, function(action, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: "danger-" + _vm.getActionKey(action, index),
                          staticClass: "table-row-actions__menu-item--danger",
                          attrs: { disabled: !!action.disabled },
                          on: {
                            click: function($event) {
                              return _vm.onClick(action)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: action.icon,
                                  color: "danger",
                                  size: _vm.iconSize
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "table-row-actions__danger-text" },
                            [_vm._v(" " + _vm._s(action.tooltip) + " ")]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }